import React from 'react';

export const CaretSide: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width || '1em'} height={height || '1em'} viewBox="0 0 128 128">
        <path fill={color || 'currentColor'} d="M32.66,114.4,81.25,65.81a2.56,2.56,0,0,0,0-3.62L32.66,13.6a2.56,2.56,0,0,1,0-3.65l3.49-3.36a2.56,2.56,0,0,1,3.58,0L95.34,62.19a2.58,2.58,0,0,1,0,3.62L39.77,121.38a2.56,2.56,0,0,1-3.58,0l-3.49-3.36A2.56,2.56,0,0,1,32.66,114.4Z"/>
    </svg>
);
